export const shouldHideSupportChat =
  window.location.href.includes('/invoice/') || window.location.href.includes('?app=mob');
